module.exports = __webpack_public_path__ + "img/tip.509cfc44.png";